import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from '../../shared/axios/axios';
import newAxios from '../../shared/axios/new-api-axios';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { hot } from 'react-hot-loader/root';

import { Card, Spin } from 'antd';

import { ExclamationCircleOutlined } from '@ant-design/icons';

import { FileNavigator } from './fileManager/client';

import withErrorHandler from '../../hoc/withErrorHandler';

import ncConnector from './s3-connector';
import { apiOptions } from '../../shared/constants/apiOptions';
import { validateGuid } from '../../shared/utils';

import * as actions from './store/actions';
import * as sharedActions from '../../shared/store/actions';

import './ncFileManager.less';

let root;

const NCFileManager = (props) => {
  root = props.rootContainer;

  const ncFileManager = {
    ...window['ncFileManager'],
    insuredId: validateGuid(window['ncFileManager']['insuredId']),
    policyId: validateGuid(window['ncFileManager']['policyId']),
    noteId: validateGuid(window['ncFileManager']['noteId']),
    taskId: validateGuid(window['ncFileManager']['taskId']),
    agencyId: validateGuid(window['ncFileManager']['agencyId']),
    agentId: validateGuid(window['ncFileManager']['agentId']),
    opportunityId: validateGuid(window['ncFileManager']['opportunityId']),
    claimId: validateGuid(window['ncFileManager']['claimId']),
    serviceRequestId: validateGuid(window['ncFileManager']['serviceRequestId']),
    ownerType: window['ncFileManager']['ownerType'],
    isOnCertsPage: window['ncFileManager']['isOnCertsPage'],
  };

  window['ncFileManager'] = ncFileManager;

  const { permissions } = useSelector((state) => state.permissions);
  const { controlConfiguration, verifyFolderStructureResult } = useSelector((state) => state.files);

  const dispatch = useDispatch();

  useEffect(() => {
    if (window.ncFileManagerSettings && window.ncFileManagerSettings.popupMode) {
      window.ncFileManagerSettings.initControl = async () => {
        initialize();
      };
      return;
    }

    initialize();
  }, []);

  useEffect(() => {
    if (verifyFolderStructureResult) {
      if (!permissions) {
        dispatch(sharedActions.getPermissions());
      }

      if (!controlConfiguration) {
        dispatch(actions.getFilesControlConfiguration());
      }
    }
  }, [verifyFolderStructureResult]);

  const initialize = () => {
    dispatch(
      actions.verifyFolderStructure({
        insuredId: validateGuid(window['ncFileManager']['insuredId']),
        policyId: validateGuid(window['ncFileManager']['policyId']),
        noteId: validateGuid(window['ncFileManager']['noteId']),
        taskId: validateGuid(window['ncFileManager']['taskId']),
        agencyId: validateGuid(window['ncFileManager']['agencyId']),
        agentId: validateGuid(window['ncFileManager']['agentId']),
        opportunityId: validateGuid(window['ncFileManager']['opportunityId']),
        claimId: validateGuid(window['ncFileManager']['claimId']),
        serviceRequestId: validateGuid(window['ncFileManager']['serviceRequestId']),
        ownerType: window['ncFileManager']['ownerType'],
        isOnCertsPage: window['ncFileManager']['isOnCertsPage'],
        currentFullURL: window.location.href,
      }),
    );
  };

  let content = (
    <DndProvider backend={HTML5Backend}>
      <Card style={{ height: '100%' }} bodyStyle={{ height: '100%', padding: '0', margin: '0' }}>
        <div data-test-id="filemanager" className="oc-fm--file-manager">
          <div className="oc-fm--file-manager__navigators">
            <div className="oc-fm--file-manager__navigator">
              {permissions && controlConfiguration && verifyFolderStructureResult ? (
                permissions?.filePermissions?.canView ? (
                  <FileNavigator
                    id="filemanager-1"
                    rootContainer={props.rootContainer}
                    api={ncConnector.api}
                    apiOptions={{ ...apiOptions, ...ncConnector.apiOptions }}
                    capabilities={ncConnector.capabilities}
                    listViewLayout={ncConnector.listViewLayout}
                    viewLayoutOptions={ncConnector.viewLayoutOptions}
                    permissions={permissions}
                    controlConfiguration={controlConfiguration}
                    ownerType={window['ncFileManager'] ? window['ncFileManager']['ownerType'] : null}
                    isOnCertsPage={window['ncFileManager'] ? window['ncFileManager']['isOnCertsPage'] : null}
                  />
                ) : (
                  <div
                    className="text-primary"
                    style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}
                  >
                    <p style={{ fontSize: 'xx-large', marginBottom: '0px' }}>
                      <ExclamationCircleOutlined />
                    </p>
                    <p>You don't have permission to view this content. Please contact your administrator.</p>
                  </div>
                )
              ) : (
                <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Spin
                    tip="Setting up your files and folders... We're just double-checking they didn't go on a coffee break. Hang tight!"
                    spinning={true}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Card>
    </DndProvider>
  );

  return <div className="file-manager-container">{content}</div>;
};

export default hot(withErrorHandler(NCFileManager, axios, root, newAxios));
